
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_1eh7m_99",
  "checkbox-control": "awsui_checkbox-control_k2y2q_1eh7m_135",
  "outline": "awsui_outline_k2y2q_1eh7m_143"
};
  